const Tab3 = () => <>Hello this is the content of tab3</>;

export default Tab3;
